module.exports = __webpack_public_path__ + "assets/7ed432811e1b5ea59a0835b254540446.mp3";